import React from 'react';
import { Leaf, Heart } from 'lucide-react';

const Footer = () => (
  <footer className="bg-emerald-950 text-emerald-100">
    <div className="max-w-7xl mx-auto px-4 py-10 grid gap-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-emerald-700 flex items-center justify-center"><Leaf className="w-5 h-5 text-white" /></div>
          <div>
            <div className="font-serif text-lg">Win With Meditation</div>
            <div className="text-[10px] uppercase tracking-widest text-emerald-300">winwithmeditation.com</div>
          </div>
        </div>
        <p className="mt-4 text-sm text-emerald-200/80 leading-relaxed">A peaceful, ad-free sanctuary of guided meditations and daily affirmations in English &amp; हिंदी. Handcrafted for calm, clarity, and inner strength.</p>
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-emerald-300">Explore</div>
        <ul className="mt-3 space-y-2 text-sm">
          <li><a href="#meditations" className="hover:text-white">Meditations</a></li>
          <li><a href="#affirmations" className="hover:text-white">Affirmations</a></li>
          <li><a href="#box-breathing" className="hover:text-white">Box Breathing</a></li>
          <li><a href="#feedback" className="hover:text-white">Community Feedback</a></li>
          <li><a href="#creator" className="hover:text-white">Creator's Story</a></li>
        </ul>
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-emerald-300">A Gentle Reminder</div>
        <p className="mt-3 text-sm text-emerald-200/80 leading-relaxed italic">"You are exactly where you need to be. Breathe. Rest. Begin again."</p>
      </div>
    </div>
    <div className="border-t border-emerald-800/70">
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between text-xs text-emerald-300 gap-2">
        <div>© {new Date().getFullYear()} winwithmeditation.com — All rights reserved.</div>
        <div className="inline-flex items-center gap-1.5">Made with <Heart className="w-3.5 h-3.5 fill-rose-400 text-rose-400" /> for calm minds worldwide.</div>
      </div>
    </div>
  </footer>
);

export default Footer;
